import { createSlice } from "@reduxjs/toolkit";
import { useInjectReducer } from "utils/@reduxjs/useInjectReducer";
import { useInjectSaga } from "utils/@reduxjs/useInjectSaga";
import { authSaga } from "./saga";

export const initialState = {
  authUser: {
    user: null,
    loading: true,
    error: null
  }
};

export const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    checkAuthRequest: (state) => {
      state.authUser.loading = true;
      state.authUser.error = null;
    },
    checkAuthSuccess: (state, action) => {
      state.authUser.user = action.payload.user;
      state.authUser.loading = false;
      state.authUser.error = null;
    },
    checkAuthFailure: (state, action) => {
      state.authUser.user = null;
      state.authUser.loading = false;
      state.authUser.error = action.payload;
    }
  }
});

export const useAuthSlice = () => {
  useInjectReducer(AuthSlice.name, AuthSlice.reducer);
  useInjectSaga(AuthSlice.name, authSaga);
  return { actions: AuthSlice.actions };
};

export const { actions: authActions } = AuthSlice;

export default AuthSlice.reducer;
